




















































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import FileThumbnail from '@/components/FileThumbnail.vue'
import DropzoneOrChooseFile from '@/components/DropzoneOrChooseFile.vue'
// @ts-ignore
import {Cropper} from 'vue-advanced-cropper'
import {Modal} from 'simpli-web-sdk'
import {IFile} from '@/interfaces/IFile'
import {nanoid} from 'nanoid'

@Component({
  components: {DropzoneOrChooseFile, FileThumbnail, Cropper, Modal},
})
export default class FileManager extends Vue {
  @Prop({type: [Array, String], default: null}) value!: string[] | string | null
  @Prop({type: Array, default: () => []}) files!: IFile[]
  @Prop({type: Array, default: []}) allowedFileTypes!: string[]
  @Prop({type: String, default: null}) exampleImage!: string
  @Prop({type: Boolean, default: false}) crop!: boolean
  @Prop({type: Boolean, default: true}) showFileName!: boolean
  @Prop({type: Number, default: null}) compressDimension!: number | null
  @Prop({type: Function, required: true}) getUploadUrl!: (
    idResponsavel: number,
    extension: string,
    name?: string | null
  ) => Promise<{
    url: string
    displayUrl: string
  }>
  @Prop({type: Function}) postUploadFile?: (
    base64UrlSafe: string
  ) => Promise<string>
  @Prop({type: Boolean, default: true}) asImage!: boolean
  @Prop({type: Boolean, default: false}) useQueue!: boolean
  @Prop({type: Number, default: 0}) maxNumberOfImages!: number
  @Prop({type: Number, required: true}) idResponsavel!: number
  @Prop({type: Boolean, default: false}) isLogo!: boolean

  fileName: string | null = null
  fileExtension: string | null = null
  imageUrlToCrop: string | null = null
  imageUrlCropped: string | null = null

  uploadQueue: ArrayBuffer[] = []

  get computedModel() {
    return this.value
  }

  set computedModel(val: string[] | string | null) {
    this.$emit('input', val)
  }

  get isEmpty() {
    return !this.value || !this.value.length
  }

  get fileTypesForPrompt() {
    return this.allowedFileTypes.join(',')
  }

  get isMultiFiles() {
    return this.value instanceof Array
  }

  get computedModelAsString() {
    if (this.isMultiFiles) {
      return (this.computedModel as string[])?.[0]
    } else {
      return this.computedModel as string
    }
  }

  get computedModelAsStringToDisplay() {
    if (this.isMultiFiles) {
      return (
        this.files?.[0]?.displayUrl || (this.computedModel as string[])?.[0]
      )
    } else {
      return this.files?.[0]?.displayUrl || (this.computedModel as string)
    }
  }

  get computedModelFiles() {
    if (this.isMultiFiles) {
      return (this.computedModel as string[]).map((url, index) => ({
        url,
        displayUrl: this.files[index]?.displayUrl || null,
      }))
    } else {
      return [
        {
          url: this.computedModel,
          displayUrl: this.files[0]?.displayUrl || null,
        },
      ]
    }
  }

  get computedModeAsArray() {
    if (this.isMultiFiles) {
      return this.computedModel as string[]
    } else {
      return [this.computedModel]
    }
  }

  get remainingSize() {
    return (
      this.maxNumberOfImages -
      (this.computedModeAsArray.length + this.uploadQueue.length)
    )
  }

  add(val: string) {
    if (this.isMultiFiles) {
      this.computedModel = [...(this.computedModel as string[]), val]
    } else {
      this.computedModel = val
    }
  }

  addFile(val: IFile) {
    this.files.push(val)
  }

  remove(index: number) {
    if (this.isMultiFiles) {
      const copy = (this.computedModel as string[]).slice()
      copy.splice(index, 1)
      this.computedModel = copy
    } else {
      this.computedModel = null
    }
    this.removeFile(index)
  }

  removeFile(index: number) {
    this.files.splice(index, 1)
  }

  removeQueue(index: number) {
    this.uploadQueue.splice(index, 1)
  }

  clearQueue() {
    this.uploadQueue = []
  }

  async processFiles(files: File[]) {
    if (this.maxNumberOfImages && files.length > this.remainingSize) {
      this.$snotify.error('system.error.exceedMaxNumberOfImages')
    }

    const promises: Array<Promise<any>> = []
    for (const f of files) {
      promises.push(this.processFile(f))
    }
    await Promise.all(promises)
  }

  async processFile(file: File) {
    this.fileName = this.isLogo
      ? `_url_logo_${nanoid(9)}`
      : file.name.split('.')[0]
    this.fileExtension = file.name.split('.').pop() ?? null

    const name = this.fileName
    const extension = this.fileExtension ?? null

    if (!this.fileExtension || !this.isFileTypeAllowed(this.fileExtension)) {
      this.$snotify.error('system.error.fileTypeNotAllowed')
      return
    }

    if (this.crop) {
      const blob = await this.$file.compressFile(file, {
        maxWidth: 5000,
        maxHeight: 5000,
      })

      this.imageUrlToCrop = await this.$file.blobToUrl(blob)
    } else {
      let arrBuffer: ArrayBuffer | null
      if (this.compressDimension) {
        const blob = await this.$file.compressFile(file, {
          maxWidth: this.compressDimension,
          maxHeight: this.compressDimension,
        })
        arrBuffer = await this.$file.blobToArrBuffer(blob)
      } else {
        arrBuffer = await this.$file.fileToArrBuffer(file)
      }

      await this.uploadOrQueue(arrBuffer, name, extension)
    }
  }

  onCropChange(e: any) {
    if (e.canvas) {
      this.imageUrlCropped = e.canvas.toDataURL()
    }
  }

  async finishCrop() {
    this.imageUrlToCrop = null
    if (this.imageUrlCropped) {
      let arrBuffer: ArrayBuffer | null
      if (this.compressDimension) {
        const blob = await this.$file.urlToBlob(this.imageUrlCropped)
        const compressedBlob = await this.$file.compressFile(blob, {
          maxWidth: this.compressDimension,
          maxHeight: this.compressDimension,
        })
        arrBuffer = await this.$file.blobToArrBuffer(compressedBlob)
      } else {
        arrBuffer = await this.$file.urlToArrayBuffer(this.imageUrlCropped)
      }
      await this.uploadOrQueue(arrBuffer)
    }
  }

  isFileTypeAllowed(fileType: string) {
    return this.allowedFileTypes.some(aft =>
      fileType.toLowerCase().endsWith(aft)
    )
  }

  async uploadOrQueue(
    arrBuffer: ArrayBuffer | null,
    fileName?: string,
    fileExtension?: string | null
  ) {
    if (this.useQueue) {
      if (!arrBuffer) {
        this.$snotify.error('system.error.unexpectedFileError')
        return
      }

      if (!this.isMultiFiles) {
        this.clearQueue()
      }

      this.uploadQueue.push(arrBuffer)
      this.$emit('queue')
    } else {
      await this.upload(arrBuffer, fileName, fileExtension)
    }
  }

  public async processQueue() {
    for (let i = 0; i < this.uploadQueue.length; i++) {
      await this.upload(this.uploadQueue[i])
      this.uploadQueue.splice(i, 1)
      i--
    }
  }

  async upload(
    arrBuffer: ArrayBuffer | null,
    fileName?: string,
    fileExtension?: string | null
  ) {
    if (!this.fileExtension) {
      return
    }

    const {url: uploadUrl, displayUrl} = await this.getUploadUrl(
      this.idResponsavel,
      fileExtension || this.fileExtension,
      fileName || this.fileName
    )

    if (!arrBuffer) {
      this.$snotify.error('system.error.unexpectedFileError')
      return
    }

    try {
      await this.$file.uploadToS3(uploadUrl, arrBuffer)
      const path = new URL(uploadUrl).pathname
      const origin = new URL(uploadUrl).origin
      const fullpath = `${origin}${path}`
      this.add(fullpath)
      if (!this.isMultiFiles) {
        this.files = []
      }
      this.addFile({
        url: fullpath,
        type: fileExtension || null,
        sizeInBytes: arrBuffer.byteLength,
        displayUrl: displayUrl,
      })
    } catch {
      this.$snotify.error('system.error.unexpectedFileError')
    }
  }
}
